import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from './axios';
import { updateSessionStatusByFirebase } from '@/lib/db';
export const toast = (toaster, message, status) => {
  toaster({
    title: message,
    description: '',
    status: status,
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  });
}
export const userLogout = (dispatch, router) => {
  dispatch(logout());
  router.push("/login");
}

export const login = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('login', credentials);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});

export const verifyOtp = createAsyncThunk('auth/checkotp', async (credentials, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('checkotp', credentials);
    console.log(response, "response")
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});

export const signup = createAsyncThunk('auth/signup', async (credentials, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('signup', { ...credentials, role: 'mentee' });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});

export const forgotPassword = createAsyncThunk('auth/forgotPassword', async (email, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('forgotPassword', { email });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});

export const resetPassword = createAsyncThunk('auth/resetPassword', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('resetPassword', data);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const changePassword = createAsyncThunk('auth/changePassword', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('changePassword', data);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const updateUser = createAsyncThunk(
  "auth/updateUser",
  async (data, { rejectWithValue }) => {
    try {
      const user = (data?._id ? data : JSON.parse(localStorage.getItem('user'))) || null;
      const response = await axiosInstance.post('user?id=' + user?._id, data);
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 401) {
        let u = JSON.parse(localStorage.getItem('user'));
        updateSessionStatusByFirebase(false, false, u?._id);
      }
      return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
    }
  }
);
export const getUsers = createAsyncThunk('auth/getUsers', async ({ page, limit, search, sortBy, sortOrder, status, role, userSide }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('user', {
      params: { page, limit, search, sortBy, sortOrder, status, role, userSide },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const getUser = createAsyncThunk('auth/getUser', async ({ id }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('user', {
      params: { id },
    });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const contact = createAsyncThunk('auth/contact', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('contact', data);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const stripeAccountConnect = createAsyncThunk('/', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${BackendUrlEmail}/sendgrid/stripe-connect`, data);
    return response.data.data;
  } catch (error) {
    console.log(error, "error");
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const getContacts = createAsyncThunk('auth/getContacts', async ({ page, limit, search, sortBy, sortOrder }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('contact', {
      params: { page, limit, search, sortBy, sortOrder },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const fetchIndustries = createAsyncThunk('auth/fetchIndustries', async ({ page, limit, search }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`industries`);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || error?.message || 'An error occurred');
  }
});
export const fetchServices = createAsyncThunk('auth/fetchServices', async ({ page, limit, search }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`service`);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || error?.message || 'An error occurred');
  }
});
export const fetchCareers = createAsyncThunk('auth/fetchCareers', async ({ page, limit, search }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`careers`);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || error?.message || 'An error occurred');
  }
});
export const fetchSkills = createAsyncThunk('auth/fetchSkills', async ({ page, limit, search }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`skills`);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || error?.message || 'An error occurred');
  }
});
export const manageJob = createAsyncThunk('auth/manageJob', async ({ data, type, id }, { rejectWithValue }) => {
  try {
    const response = type === 'del' ? await axiosInstance.delete(`jobs?job_id=${id}`) : await axiosInstance.post(id ? `jobs?job_id=${id}` : 'jobs', data);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const manageUserServices = createAsyncThunk('auth/manageUserServices', async ({ data, type, id }, { rejectWithValue }) => {
  try {
    const response = type === 'del' ? await axiosInstance.delete(`userServices?service_id=${id}`) : await axiosInstance.post(id ? `userServices?service_id=${id}` : 'userServices', data);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const manageCMS = createAsyncThunk('auth/manageCMS', async ({ data, method, id, type }, { dispatch, rejectWithValue }) => {
  try {
    const response = method === 'get' ? await axiosInstance.get('cms', {
      params: { type },
    }) : method === 'del' ? await axiosInstance.delete(`cms?id=${id}`)
      : await axiosInstance.post(id ? `cms?id=${id}` : 'cms', data, {
        params: { type },
      });

    if (type === "faqs_mentee") {
      dispatch(menteeFaq(response.data.data));
    }

    if (type === "faqs_mentor") {
      dispatch(mentorFaq(response.data.data));
    }

    return method === 'get' ? {
      type,
      method,
      data: response.data.data
    } : response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});

export const manageSessions = createAsyncThunk('auth/manageSessions', async ({ data, method, id }, { rejectWithValue }) => {

  try {
    const response = method === 'get' ? await axiosInstance.get('session', {
      params: { id },
    }) : method === 'del' ? await axiosInstance.delete(`session?id=${id}`)
      : await axiosInstance.post(id ? `session?id=${id}` : 'session', data, {
        params: {},
      });

    return method === 'get' ? {
      method,
      id,
      data: response.data.data
    } : response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || error.response?.data?.error || 'An error occurred');
  }
});
export const manageDisputes = createAsyncThunk('auth/manageDisputes', async ({ data, method, id }, { rejectWithValue }) => {
  try {
    const response = method === 'get' ? await axiosInstance.get('disputes', {
      params: { id },
    }) : method === 'del' ? await axiosInstance.delete(`disputes?id=${id}`)
      : await axiosInstance.post(id ? `disputes?id=${id}` : 'disputes', data, {
        params: {},
      });
    return method === 'get' ? {
      method,
      id,
      data: response.data.data
    } : response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      let u = JSON.parse(localStorage.getItem('user'));
      updateSessionStatusByFirebase(false, false, u?._id);
    }
    return rejectWithValue(error.response?.data?.message || 'An error occurred');
  }
});

let storedUser = null;
if (typeof window !== "undefined") {
  try {
    const item = localStorage.getItem("user");
    storedUser = item ? JSON.parse(item) : null;
  } catch (err) {
    storedUser = null; // fallback if JSON invalid
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    loading: false,
    industries: [],
    services: [],
    careers: [],
    skills: [],
    // user: typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : null,
    user: storedUser,
    error: null,
    uservices: [],
    users: [],
    user_total: 0,
    singal_user: null,
    contacts: [],
    contact_total: 0,
    disputes: [],
    sessions: [],
    faqs: [],
    faqs_mentor: [],
    faqs_mentee: [],
    helpCenter: [],
    testimonials: [],
    singleSession: null
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    },
    menteeFaq: (state, action) => {
      state.faqs_mentee = action.payload;
    },
    mentorFaq: (state, action) => {
      state.faqs_mentor = action.payload;
    },
    resetAuth: (state) => {
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => { state.loading = true; })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.token = action.payload.token;
        localStorage.setItem('user', JSON.stringify(action.payload.data));
        localStorage.setItem('token', action.payload.token);
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(signup.pending, (state) => { state.loading = true; })
      .addCase(signup.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.token = action.payload.token;
        localStorage.setItem('user', JSON.stringify(action.payload.data));
        localStorage.setItem('token', action.payload.token);
      })
      .addCase(signup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(verifyOtp.pending, (state) => { state.loading = true; })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.token = action.payload.token;
        localStorage.setItem('user', JSON.stringify(action.payload.data));
        localStorage.setItem('token', action.payload.token);
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(forgotPassword.pending, (state) => { state.loading = true; })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(resetPassword.pending, (state) => { state.loading = true; })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(changePassword.pending, (state) => { state.loading = true; })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUser.pending, (state) => { state.loading = true; })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        if (state?.user?._id === action?.payload?._id) {
          state.user = { ...state?.user, ...action?.payload };
          localStorage.setItem('user', JSON.stringify({ ...state?.user, ...action?.payload }));
        } else {
          state.singal_user = { ...action?.payload };
        }
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchIndustries.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIndustries.fulfilled, (state, action) => {
        state.loading = false;
        state.industries = action.payload;
      })
      .addCase(fetchIndustries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false;
        state.services = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCareers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCareers.fulfilled, (state, action) => {
        state.loading = false;
        state.careers = action.payload;
      })
      .addCase(fetchCareers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSkills.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSkills.fulfilled, (state, action) => {
        state.loading = false;
        state.skills = action.payload;
      })
      .addCase(fetchSkills.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload.data;
        state.user_total = action.payload.total;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.singal_user = action.payload;
        if (state?.user?._id === action?.payload?._id) {
          state.user = { ...state?.user, ...action?.payload };
          localStorage.setItem('user', JSON.stringify({ ...state?.user, ...action?.payload }));
        }
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(contact.pending, (state) => {
        state.loading = true;
      })
      .addCase(contact.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(contact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getContacts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContacts.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = action.payload.data;
        state.contact_total = action.payload.total;
      })
      .addCase(getContacts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(manageJob.pending, (state) => {
        state.loading = true;
      })
      .addCase(manageJob.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(manageJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(manageUserServices.pending, (state) => {
        state.loading = true;
      })
      .addCase(manageUserServices.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(manageUserServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(manageCMS.pending, (state) => {
        state.loading = true;
      })
      .addCase(manageCMS.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.method === 'get') {
          state[action.payload.type] = action.payload.data
        }
      })
      .addCase(manageCMS.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(manageSessions.pending, (state) => {
        state.loading = true;
      })
      .addCase(manageSessions.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.method === 'get') {
          state.sessions = action.payload.data
        }
        if (action.payload.id) {
          state.singleSession = action.payload.data;
        }
      })
      .addCase(manageSessions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(manageDisputes.pending, (state) => {
        state.loading = true;
      })
      .addCase(manageDisputes.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.method === 'get') {
          state.disputes = action.payload.data
        }
      })
      .addCase(manageDisputes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      ;
  },
});
export const { logout, menteeFaq, mentorFaq, resetAuth } = authSlice.actions;
export default authSlice.reducer;